import { useTranslation } from "react-i18next";
import SkeletonLoader from "../../components/Loaders/SkeletonLoader";
import { formatAmountRounded } from "../../utils/formatters";
import { Link } from "@sebgroup/green-react";
import ExternalLinkSquareIcon from "../../components/Icons/ExternalLinkSquareIcon";

const environment = import.meta.env;

interface PreliminaryPeriodFeeCardProps {
  loading?: boolean;
  periodFee?: number;
  numberFormat: string;
  language?: string;
  onComplete?: () => void;
}

function PreliminaryPeriodFeeCard(props: PreliminaryPeriodFeeCardProps) {
  const { t } = useTranslation();

  const label_preliminaryleasingfee = t("label_preliminaryleasingfee");
  const label_kr_currencylong = t("label_kr_currencylong");
  const label_loginandapply = t("label_loginandapply");
  const button_loginandapply = t("button_loginandapply");
  const path_loginandapply = `${environment.VITE_REDIRECT_LOG_IN_AND_APPLY_PATH}${props.language ? `?language=${props.language}` : ""}`;
  const label_becomeacustomer = t("label_becomeacustomer");
  const button_becomeacustomer = t("button_becomeacustomer");
  const path_becomeacustomer = environment.VITE_REDIRECT_BECOME_A_CUSTOMER_PATH;

  return (
    <section className="summary-box" data-testid="summary-box__testid">
      <header className="summary-box__header" aria-live={!props.loading && props.periodFee ? "polite" : undefined}>
        <div
          className="summary-box__header__title"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: label_preliminaryleasingfee }}
        />
        {props.loading ? (
          <SkeletonLoader />
        ) : (
          <div id="period-fee" data-testid="summary-box-period-fee__testid" className="summary-box__header__period-fee">
            {formatAmountRounded(props.periodFee, props.numberFormat, "-")} {label_kr_currencylong}
          </div>
        )}
      </header>
      <div className="summary-box-content">
        <div className="summary-box__content__item">
          <div className="summary-box__content__item__label">{label_loginandapply}</div>
          <Link className="summary-box__content__item__link" button="primary" href={path_loginandapply} onClick={props.onComplete}>
            {button_loginandapply}
            <ExternalLinkSquareIcon />
          </Link>
        </div>
        <div className="summary-box__content__item">
          <div className="summary-box__content__item__label">{label_becomeacustomer}</div>
          <Link className="summary-box__content__item__link" button="secondary" href={path_becomeacustomer} onClick={props.onComplete}>
            {button_becomeacustomer}
            <ExternalLinkSquareIcon />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default PreliminaryPeriodFeeCard;
